import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBrushToolSmart = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 33 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M15.9999 23C13.9999 21 28.778 10.7125 23.9999 5.5C19.8625 0.986458 12.3298 8.92251 7.99995 13.9831L7.5 17.5291L11.0001 17.075C14.4595 13.0395 19.5186 7.25934 20.9999 8C23.9999 9.5 8.99995 20.5 13.9999 25C18.9999 29.5 25.2259 17.3173 26.9999 18.5C28.774 19.6827 21.4999 24 24.9999 26.5C27.8821 28.5587 30.5 24 29.9999 23.5C29.4999 23 27.2499 26.25 26.2499 25.25C24.7499 23.75 32.5 19.5 28.4999 16.5C24.4999 13.5 17.9999 25 15.9999 23Z",
			fill: "url(#paint0_linear)"
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_d)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M7.32234 14.0646C7.45988 13.2393 7.52865 12.8267 7.6142 12.7231C7.81418 12.4809 8.18533 12.4809 8.38532 12.7231C8.47086 12.8267 8.53963 13.2393 8.67718 14.0646C8.76116 14.5685 8.80316 14.8205 8.89311 15.0351C9.0959 15.5191 9.48076 15.9039 9.9647 16.1067C10.1793 16.1967 10.4313 16.2387 10.9352 16.3226C11.7605 16.4602 12.1731 16.529 12.2767 16.6145C12.5189 16.8145 12.5189 17.1856 12.2767 17.3856C12.1731 17.4712 11.7605 17.5399 10.9352 17.6775C10.4313 17.7615 10.1793 17.8035 9.9647 17.8934C9.48076 18.0962 9.0959 18.4811 8.89311 18.965C8.80316 19.1796 8.76116 19.4316 8.67718 19.9355C8.53963 20.7608 8.47086 21.1734 8.38532 21.277C8.18533 21.5192 7.81418 21.5192 7.6142 21.277C7.52865 21.1734 7.45988 20.7608 7.32234 19.9355C7.23835 19.4316 7.19635 19.1796 7.10641 18.965C6.90361 18.4811 6.51875 18.0962 6.03481 17.8934C5.82018 17.8035 5.56821 17.7615 5.06427 17.6775C4.23903 17.5399 3.8264 17.4712 3.72279 17.3856C3.48059 17.1856 3.48059 16.8145 3.72279 16.6145C3.8264 16.529 4.23903 16.4602 5.06427 16.3226C5.56821 16.2387 5.82018 16.1967 6.03481 16.1067C6.51875 15.9039 6.90361 15.5191 7.10641 15.0351C7.19635 14.8205 7.23835 14.5685 7.32234 14.0646Z",
				fill: "#5531FF"
			})
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("filter", {
			id: "filter0_d",
			x: .541016,
			y: 10.5414,
			width: 14.9172,
			height: 14.9172,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.5 }),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.333333 0 0 0 0 0.192157 0 0 0 0 1 0 0 0 0.6 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow",
					result: "shape"
				})
			]
		}), /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear",
			x1: 11.4999,
			y1: 10,
			x2: 29.9999,
			y2: 27,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				stopColor: "#7F64FF",
				stopOpacity: .8
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#7F64FF",
				stopOpacity: .4
			})]
		})] })
	]
});
const ForwardRef = forwardRef(SvgBrushToolSmart);
export { ForwardRef as ReactComponent };
